export default __webpack_public_path__ + "static/media/nftplaceholder.4ea6283c.png";